module.exports = __webpack_public_path__ + "static/media/cafeirisfinal.e1030d45.png";